import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentAgenda, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAppointmentAgendaProps {
  date: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useAppointmentAgenda({
  date,
  coaches,
  locations,
  eventTypes,
}: IUseAppointmentAgendaProps): UseQueryResult<{ data: Array<AppointmentAgenda> }> {
  const params: UrlParams = { date };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(['appointments', 'agenda', date, coaches, eventTypes, locations], () =>
    client.get(`appointments/agenda/?${encodeUrlParams(params)}`),
  );
}

export default useAppointmentAgenda;
